import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { translate } from '@/ui/i18n';

export function ShowExternalPublicInfos({
  invitationPublic,
}: {
  invitationPublic: ExternalInvitation;
}) {
  const eventPositionLabel = invitationPublic.eventPosition
    ? invitationPublic.eventPosition.properties.name
    : '-';
  const limitDate = invitationPublic.expirationDate
    ? dayjs(invitationPublic.expirationDate).format('DD/MM/YYYY')
    : '-';
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        spacing: 2,
      }}
    >
      <Typography sx={{ fontWeight: 'bold' }}>
        {translate(
          'InviteExternalToFill.create-and-send-invitation.event-position',
        )}
        {' : '}
        <Typography component="span">{eventPositionLabel}</Typography>
      </Typography>
      <Typography sx={{ fontWeight: 'bold' }}>
        {translate(
          'InviteExternalToFill.create-and-send-invitation.limit-date',
        )}
        {' : '}
        <Typography component="span">{limitDate}</Typography>
      </Typography>
    </Box>
  );
}
